// V43: LIGHTWEIGHT HOTWIRE (Best of V39 + V42)
// 1. DESKTOP: Hotwires thumbnails to GUARANTEE they work (Fixes First Load Freeze).
// 2. MOBILE: Passive text stamping (Fixes Visibility + Arrows).
// 3. PERFORMANCE: Uses V42's gentle loop (Fixes Lag).

(function() {
    if (window.galleryV43Running) return;
    window.galleryV43Running = true;

    // --- 1. DATA DICTIONARY ---
    const modelData = {
'andrea-l': "Andrea is 5'10\" in size L",
'andrea-l-long': "Andrea is 5'10\" in size L, long fit",
'andrea-l-regular': "Andrea is 5'10\" in size L, regular fit",
'bethany-s': "Bethany is 5'11\" in size S",
'bethany-s-regular': "Bethany is 5'11\" in size S, regular fit",
'bethany-s-long': "Bethany is 5'11\" in size S, long fit",
'bonnie-xs': "Bonnie is 5'0\" in size XS",
'bonnie-xs-petite': "Bonnie is 5'0\" in size XS, petite fit",
'bonnie-xs-regular': "Bonnie is 5'0\" in size XS, regular fit",
'bri-xl': "Bri is 5'5\" in size XL",
'bri-xxl': "Bri is 5'5\" in size XXL",
'bri-xl-petite': "Bri is 5'5\" in size XL, petite fit",
'bri-xl-regular': "Bri is 5'5\" in size XL, regular fit",
'bri-xxl-petite': "Bri is 5'5\" in size XXL, petite fit",
'bri-xxl-regular': "Bri is 5'5\" in size XXL, regular fit",
'carley-xxl': "Carley is 5'2\" in size XXL",
'carley-xxl-petite': "Carley is 5'2\" in size XXL, petite fit",
'carley-xxl-regular': "Carley is 5'2\" in size XXL, regular fit",
'carolyn-l': "Carolyn is 5'10\" in size L",
'carolyn-m': "Carolyn is 5'10\" in size M",
'carolyn-l-long': "Carolyn is 5'10\" in size L, long fit",
'carolyn-l-regular': "Carolyn is 5'10\" in size L, regular fit",
'carolyn-m-long': "Carolyn is 5'10\" in size M, long fit",
'carolyn-m-regular': "Carolyn is 5'10\" in size M, regular fit",
'christal-m': "Christal is 5'3\" in size M",
'christal-s': "Christal is 5'3\" in size S",
'christal-m-petite': "Christal is 5'3\" in size M, petite fit",
'christal-m-regular': "Christal is 5'3\" in size M, regular fit",
'christal-s-petite': "Christal is 5'3\" in size S, petite fit",
'christal-s-regular': "Christal is 5'3\" in size S, regular fit",
'christine-l': "Christine is 5'9\" in size L",
'christine-l-long': "Christine is 5'9\" in size L, long fit",
'christine-l-regular': "Christine is 5'9\" in size L, regular fit",
'colleen-xl': "Colleen is 5'3\" in size XL",
'colleen-xxl': "Colleen is 5'3\" in size XXL",
'colleen-xl-petite': "Colleen is 5'3\" in size XL, petite fit",
'colleen-xxl-petite': "Colleen is 5'3\" in size XXL, petite fit",
'cristina-xl': "Cristina is 5'5\" in size XL",
'cristina-xxl': "Cristina is 5'5\" in size XXL",
'cristina-xl-petite': "Cristina is 5'5\" in size XL, petite fit",
'cristina-xl-regular': "Cristina is 5'5\" in size XL, regular fit",
'cristina-xxl-petite': "Cristina is 5'5\" in size XXL, petite fit",
'cristina-xxl-regular': "Cristina is 5'5\" in size XXL, regular fit",
'donna-s': "Donna is 5'6\" in size S",
'donna-s-regular': "Donna is 5'6\" in size S, regular fit",
'erica-2x': "Erica is 5'8\" in size 2X",
'erica-3x': "Erica is 5'8\" in size 3X",
'erica-4x': "Erica is 5'8\" in size 4X",
'jenna-m': "Jenna is 5'9\" in size M",
'jenna-s': "Jenna is 5'9\" in size S",
'jenna-m-long': "Jenna is 5'9\" in size M, long fit",
'jenna-m-regular': "Jenna is 5'9\" in size M, regular fit",
'jenna-s-long': "Jenna is 5'9\" in size S, long fit",
'jenna-s-regular': "Jenna is 5'9\" in size S, regular fit",
'jillian-xl': "Jillian is 5'10\" in size XL",
'jillian-xxl': "Jillian is 5'10\" in size XXL",
'jillian-xl-long': "Jillian is 5'10\" in size XL, long fit",
'jillian-xl-regular': "Jillian is 5'10\" in size XL, regular fit",
'jillian-xxl-long': "Jillian is 5'10\" in size XXL, long fit",
'jillian-xxl-regular': "Jillian is 5'10\" in size XXL, regular fit",
'jo-xs': "Jo is 5'6\" in size XS",
'jo-xs-regular': "Jo is 5'6\" in size XS, regular fit",
'kaitlin-l': "Kaitlin is 5'9\" in size L",
'kaitlin-xl': "Kaitlin is 5'9\" in size XL",
'kaitlin-xxl': "Kaitlin is 5'9\" in size XXL",
'kaitlin-xl-long': "Kaitlin is 5'9\" in size XL, long fit",
'kaitlin-xl-regular': "Kaitlin is 5'9\" in size XL, regular fit",
'kaitlin-xxl-long': "Kaitlin is 5'9\" in size XXL, long fit",
'kaitlin-xxl-regular': "Kaitlin is 5'9\" in size XXL, regular fit",
'keethai-l': "Keethai is 5'5\" in size L",
'keethai-m': "Keethai is 5'5\" in size M",
'keethai-m-regular': "Keethai is 5'5\" in size M, regular fit",
'kelly-2x': "Kelly is 5'7\" in size 2X",
'kelly-3x': "Kelly is 5'7\" in size 3X",
'kelly-4x': "Kelly is 5'7\" in size 4X",
'kerri-m': "Kerri is 5'2\" in size M",
'kerri-m-petite': "Kerri is 5'2\" in size M, petite fit",
'kerri-m-regular': "Kerri is 5'2\" in size M, regular fit",
'kerri-s': "Kerri is 5'5\" in size S",
'kimesha-2x': "Kimesha is 5'8\" in size 2X",
'kimesha-3x': "Kimesha is 5'8\" in size 3X",
'kimesha-4x': "Kimesha is 5'8\" in size 4X",
'laurie-xl': "Laurie is 5'5\" in size XL",
'laurie-xxl': "Laurie is 5'5\" in size XXL",
'laurie-xl-petite': "Laurie is 5'5\" in size XL, petite fit",
'laurie-xl-regular': "Laurie is 5'5\" in size XL, regular fit",
'laurie-xxl-petite': "Laurie is 5'5\" in size XXL, petite fit",
'laurie-xxl-regular': "Laurie is 5'5\" in size XXL, regular fit",
'lex-xs': "Lex is 5'2\" in size XS",
'lex-xs-petite': "Lex is 5'2\" in size XS, petite fit",
'lex-xs-regular': "Lex is 5'2\" in size XS, regular fit",
'liane-s': "Liane is 5'9\" in size S",
'liane-s-long': "Liane is 5'9\" in size S, long fit",
'liane-s-regular': "Liane is 5'9\" in size S, regular fit",
'lisa-xs': "Lisa is 5'6\" in size XS",
'lisa-xs-long': "Lisa is 5'6\" in size XS, long fit",
'lisa-xs-regular': "Lisa is 5'6\" in size XS, regular fit",
'marilyn-m': "Marilyn is 5'2\" in size M",
'marilyn-s': "Marilyn is 5'2\" in size S",
'marilyn-m-petite': "Marilyn is 5'2\" in size M, petite fit",
'marilyn-m-regular': "Marilyn is 5'2\" in size M, regular fit",
'marilyn-s-petite': "Marilyn is 5'2\" in size S, petite fit",
'marilyn-s-regular': "Marilyn is 5'2\" in size S, regular fit",
'melanie-m': "Melanie is 5'9\" in size M",
'melanie-m-long': "Melanie is 5'9\" in size M, long fit",
'melanie-m-regular': "Melanie is 5'9\" in size M, regular fit",
'meron-xs': "Meron is 5'3\" in size XS",
'meron-xs-petite': "Meron is 5'3\" in size XS, petite fit",
'meron-xs-regular': "Meron is 5'3\" in size XS, regular fit",
'pat-l': "Pat is 5'8\" in size L",
'pat-l-long': "Pat is 5'8\" in size L, long fit",
'pat-l-regular': "Pat is 5'8\" in size L, regular fit",
'raquel-xl': "Raquel is 5'7\" in size XL",
'raquel-xxl': "Raquel is 5'7\" in size XXL",
'raquel-xl-long': "Raquel is 5'7\" in size XL, long fit",
'raquel-xl-regular': "Raquel is 5'7\" in size XL, regular fit",
'raquel-xxl-long': "Raquel is 5'7\" in size XXL, long fit",
'raquel-xxl-regular': "Raquel is 5'7\" in size XXL, regular fit",
'yasmine-xs': "Yasmine is 5'0\" in size XS",
'yasmine-xs-petite': "Yasmine is 5'0\" in size XS, petite fit",
'yasmine-xs-regular': "Yasmine is 5'0\" in size XS, regular fit",
'sarita-2x': "Sarita is 5'7 in size 2x",
'kerri-s-regular': "Kerri is 5\"5 in size S, regular fit",
'sarita-xxl-regular': "Sarita is 5'7\" in size XXL, regular fit",
'natasha-s': "Natasha is 5'4 in size S",
'natasha-s-regular': "Natasha is 5'4 in size S, regular fit",
'natahsa-s-long': "Natahsa is 5'4 in size S, long fit",
'colleen-xxl-long': "Colleen is 5'3 in size XXL, long fit",
'keethai-m-long': "Keethai is 5'5 in size M, long fit"
    };

    // --- MAIN LOGIC ---
    function stampEverything() {
        // Scope to gallery for speed
        const viewer = document.querySelector('[id^="GalleryViewer"]');
        if (!viewer) return;

        const slides = viewer.querySelectorAll('.product__media-item');
        
        slides.forEach(slide => {
            const img = slide.querySelector('img');
            
            // 1. CLEANUP CASE 1: No Image?
            if (!img || !img.alt) {
                slide.querySelector('.overlay-text')?.remove();
                return;
            }

            // 2. EXTRACT TAG
            const parts = img.alt.split('@');
            let description = null;

            if (parts.length >= 2) {
                let rawTag = parts[1].trim(); 
                let lookupKey = rawTag.split(' ')[0].toLowerCase().replace(/[^a-z0-9-_]/g, '');
                description = modelData[lookupKey];
            }

            // 3. CLEANUP CASE 2: No Match?
            if (!description) {
                slide.querySelector('.overlay-text')?.remove();
                return;
            }

            // 4. APPLY STICKER
            const existingOverlay = slide.querySelector('.overlay-text');
            if (existingOverlay) {
                if (existingOverlay.innerHTML === description) {
                    return; // Skip if perfect
                } else {
                    existingOverlay.remove(); // Update if wrong
                }
            }

            const textContainer = document.createElement('span');
            textContainer.className = 'overlay-text';
            textContainer.innerHTML = description;

            if (window.getComputedStyle(slide).position === 'static') {
                slide.style.position = 'relative';
            }
            slide.appendChild(textContainer);
        });
    }

    // --- HOTWIRE: DESKTOP ONLY ---
    function hotwireDesktop() {
        const viewer = document.querySelector('[id^="GalleryViewer"]');
        const thumbnails = document.querySelector('[id^="GalleryThumbnails"]');
        
        if (!viewer || !thumbnails) return;

        const btns = thumbnails.querySelectorAll('button');
        btns.forEach(btn => {
            // Check if we already fixed this button
            if (btn.dataset.hotwired) return; 
            
            // Clone to strip old theme listeners (The "Freeze" Fix)
            const newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);
            newBtn.dataset.hotwired = "true"; 

            newBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const targetId = newBtn.getAttribute('data-target') || newBtn.parentNode.getAttribute('data-target');
                const targetSlide = viewer.querySelector(`[data-media-id="${targetId}"]`);
                
                if (targetSlide) {
                    // 1. Move
                    targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                    
                    // 2. Update Classes
                    viewer.querySelectorAll('.product__media-item').forEach(s => s.classList.remove('is-active'));
                    targetSlide.classList.add('is-active');

                    thumbnails.querySelectorAll('li, button').forEach(t => {
                        t.classList.remove('is-active');
                        if (t.querySelector('button')) t.querySelector('button').removeAttribute('aria-current');
                    });
                    
                    const targetThumb = thumbnails.querySelector(`[data-target="${targetId}"]`);
                    if (targetThumb) {
                        targetThumb.classList.add('is-active');
                        targetThumb.querySelector('button')?.setAttribute('aria-current', 'true');
                    }

                    // 3. Update Text
                    stampEverything();
                }
            });
        });
    }

    // --- WATCHERS ---
    
    // 1. Initial Run
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            stampEverything();
            hotwireDesktop();
        });
    } else {
        stampEverything();
        hotwireDesktop();
    }

    // 2. Gentle Loop (500ms) - Prevents lag, catches lazy loads
    setInterval(stampEverything, 500);

    // 3. Structure Watcher (Variant Switches)
    const observer = new MutationObserver((mutations) => {
        let needsHotwire = false;
        for (const m of mutations) {
            if (m.type === 'childList') needsHotwire = true;
        }
        if (needsHotwire) {
            // Re-apply hotwire if theme re-renders buttons
            setTimeout(() => {
                stampEverything();
                hotwireDesktop();
            }, 100);
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

})();